<template>
  <div>
    <div class="layout-row">
      <v-text-field
        style="min-width:130px;"
        class="flex ma-0"
        :name="name"
        ref="lxAutocompleteField"
        :dark="compColor.isInDarkMode"
        :color="compColor.primeColor"
        outlined
        :label="label"
        :hint="hint"
        :hide-details="hideDetails"
        :persistent-hint="persistent_hint"
        v-model="searchText"
        v-on:keyup="inputChanged"
        v-on:keydown="keyDown"
        @click="inputChanged"
        @blur="inputBlured"
        :disabled="disabled"
        :dense="dense"
        :error-messages="getErrorMsg"
        :required="required">
      </v-text-field>
    </div>

    <v-menu bottom
            :position-x="x"
            :position-y="y"
            transition="false"
            v-model="showLxAutocompleteMenu">
      <v-card style="overflow:hidden;box-shadow:0 5px 20px rgba(0,0,0,0.8);" :class="compColor.prime"
              class="lighten-5 layout-column"
              v-bind:style="{ maxHeight: maxHeight + 'px', minWidth: '350px', maxWidth: '600px' }"
              v-show="results.index === index && results.parentIndex === parentIndex">
        <div class="flex" style="overflow-y: auto;">
          <ul style="list-style-type: none;" class="pa-0">
            <li v-for="item in internalItems" :key="item.id" @click="selectItem(item)" class="pa-1 ma-1"
                style="cursor: pointer;">
              <slot v-bind:lineItem="item" v-bind:searchText="searchText"></slot>
            </li>
          </ul>
        </div>

        <v-divider></v-divider>

        <v-card-actions class="py-1 px-3 white--text" :class="compColor.prime">
                    <span class="body-2"
                          v-if="results.count===1">Suchabfrage lieferte <strong>{{ results.count }}</strong> Eintrag zurück</span>
          <span class="body-2" v-else>Suchabfrage lieferte <strong>{{ results.count }}</strong> Einträge zurück</span>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'lxAutocomplete',
  /**
   * ##########################################################################################################
   * #  notwendig damit Kommunikation mit der Validierung vee-validate in der Parent Komponente funktioniert  #
   * ##########################################################################################################
   * */
  $_veeValidate: {
    name() {
      return this.name
    },
    value() {
      return this.value
    }
  },
  data() {
    return {
      showChip: false,
      windowHeight: 0,
      internalItems: [],
      selectedItem: {},
      searchText: '',
      lineItem: {},
      x: 0,
      y: 0,
      showLxAutocompleteMenu: false
    }
  },
  props: {
    value: {
      type: String
    }, // der Typ den das v-model im Parent haben kann ist entweder ein Object, String oder Date
    label: {
      type: String
    },
    hint: {
      type: String
    },
    persistent_hint: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: { // bekommt die Errormessages übergeben
      type: [Array, String],
      required: false
    },
    required: {
      type: [Boolean]
    },
    hideDetails: {
      type: [Boolean],
      default: false
    },
    results: {
      type: Object,
      required: true
    },
    index: {
      type: Number
    },
    parentIndex: {
      type: Number
    },
    name: {
      type: String
    },
    dense: {
      type: Boolean,
      default: false
    },
    length: {
      type: Number
    },
    setValueOnlyPerChoice: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * wenn vee-validate in der Parentkomponente einen Fehler erkennt und damit this.error sich ändert dann werden
     * hier im Autocomplete die Errormessages getriggert durch diese computed Property
     * */
    getErrorMsg: function () {
      if (!this.error) {
        return []
      }
      return this.error
    },
    /**
     * Berechnet die maximal mögliche Popuphöhe anhand der Fenstergröße
     * */
    maxHeight: function () {
      return 250
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowHeight = window.innerHeight
      })
    })
  },
  methods: {
    /**
     * Wird aufgerufen, wenn Taste gedrückt wird
     * */
    keyDown(e) {
      // tab has no keyup event
      if (e.key === 'Tab') {
        this.showLxAutocompleteMenu = false
      }
    },
    /**
     * Wird aufgerufen wenn man:
     * 1) Ins input klickt -> Wenn Feld keinen Fokus hatte aber ein Suchtext drin steht und Ergbnisse dafür existieren
     *    soll das Popup nun mit den Ergebnissen wieder angezeigt werden.
     *    (e.type === 'click' && !this.showLxAutocompleteMenu)
     * 2) Beim Tastenanschlag -> Wenn man also im Input ist und schreibt. Überprüft wieviele Zeichen eingegeben wurden
     *    und fängt ab 2 Zeichen an die Suchfunktionn zu rufen mit dem Suchtext
     *    this.$emit('search-method', this.searchText) das Ergebnis hiervon landet dann in der results prop
     * */
    inputChanged(e) {
      e.preventDefault()

      // only one item left, user can submit this via enter key
      if (e.key === 'Enter' && this.internalItems && this.internalItems.length === 1) {
        this.selectItem(this.internalItems[0])
        this.showLxAutocompleteMenu = false
        return
      }

      const inputLength = this.length || 2

      // load values from search method
      if (this.$refs['lxAutocompleteField'] && this.$refs['lxAutocompleteField'].value && this.$refs['lxAutocompleteField'].value.length >= inputLength) {
        if (e.type === 'keyup') {
          this.$emit('search-method', this.searchText, this.index, this.parentIndex)
        } else if (e.type === 'click' && !this.showLxAutocompleteMenu) {
          this.$emit('search-method', this.searchText, this.index, this.parentIndex)
        }
      } else {
        this.showLxAutocompleteMenu = false
      }
    },
    /**
     * Wird per @blur aufgerufen wenn man das Inputfeld des Autocompletes verlässt.
     * Sollte das Model vom Parent noch leer sein dann gibt null dahin zurück.
     * Damit schlägt bei einem required die Validierung an.
     * */
    inputBlured() {
      // set empty value on undefined to provide errors in text-highlighter
      // set searchText as value, if exists to give user the possibility to set an agent, which is not part of database
      if (!this.setValueOnlyPerChoice) {
        this.$emit('input', this.searchText ? this.searchText : undefined, this.index, this.parentIndex)
      } else {
        // clear value, if search string is empty
        if (!this.searchText) {
          this.$emit('input', undefined, this.index, this.parentIndex)
        } else {
          this.searchText = this.value
        }
      }
    },
    /**
     * Wird per @click auf ein Item in der Ergebnisliste aufgerufen und wählt das angeklickte Objekt aus.
     * Dieses Item wir in this.selectedItem gespeichert. Dann in einem Chip neben dem Autocomplete angezeigt
     * mit this.showChip = true.
     * Anschließend wird der Value zum Parent emitted und somit die v-model Variable dort gesetzt
     * */
    selectItem(item) {
      this.selectedItem = item
      this.$emit('input', item, this.index, this.parentIndex)
    },
    /**
     * Wird von mehreren Stellen aus aufgerufen um als Aktion das Popup mit den Items anzuzeigen,
     * die auf die Suchanfrage zutreffen.
     * Popup wird noch an die X- und Y-Position des Inputfeldes ausgerichtet und schlußendlich durch di Variable
     * this.showLxAutocompleteMenu mit true angezeigt
     * */
    showAutocompletePopup() {
      let bounding = this.$refs['lxAutocompleteField'].$el.getBoundingClientRect()
      this.showLxAutocompleteMenu = false
      this.x = Math.round(bounding.x)
      this.y = Math.round(bounding.y) + bounding.height - 16
      this.$nextTick(() => {
        this.showLxAutocompleteMenu = true
      })
    }
  },
  watch: {
    /**
     * Watched auf die Variable/Prop results die aus dem Parent mit den Items der Sucheanfrage gefüllt wird.
     * -  Wenn welche Items vorhanden sind, dann an this.internalItems übergeben und das Popup anzeigen mittels
     *    this.showAutocompletepopup()
     * -  Wenn keine Items vorhande dann Popup ausblenden und die this.internalItems wieder auf leeres Array setzen
     *    tritt ein wenn Suche keine Ergebnisse mehr zurückliefert
     * */
    results(newValue) {
      if (newValue && newValue.result) {
        this.internalItems = newValue.result
        this.showAutocompletePopup()
      } else {
        this.internalItems = []
        this.showLxAutocompleteMenu = false
      }
    },
    /**
     * Watched auf das value bzw. das v-model des parent und schlägt bei Änderungen an.
     * Für den Fall das von außen das Model gelöscht wird und es vorher eins gab, also ein Reset durchgeführt wird,
     * werden die Items gecleared , das Ergebnisschip ausgeblende und der Suchtext gelöscht.
     * */
    value: {
      handler: function (newValue, oldValue) {
        if (newValue === undefined && oldValue) {
          this.searchText = ''
          this.selectedItem = {}
          this.showChip = false
        } else {
          this.searchText = newValue
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">

.card {
  box-shadow: none;
}

li:hover {
  background: #f0f0f0;
}

.not-in {
  color: #b9a564;
}

div.teal--text.active {
  color: #4db6ac;

  span {
    font-weight: 700;
  }
}

td {
  cursor: pointer;
}

td.active {
  div {
    font-weight: 700;
  }
}

.linked {
  cursor: pointer;
}

.other-month {
  background: #ffcb52;
  opacity: 0.4;
  color: black;
  border: 1px solid #6d6d6d;
}

table {
  border: 1px solid #222e3e2b;
}

table thead th {
  background: #e0e0e0;
  border-bottom: 1px solid #4cb6ac !important;

  &:first-child {
    padding-right: 10px;
    background: rgba(0, 150, 136, 0.13);
  }

  div {
    text-align: center;
    line-height: 30px;
    width: 30px;
    height: 30px;
  }
}

table tbody td {
  border: 1px solid #4cb6ac;

  &:first-child {
    padding-right: 10px;
  }

  div {
    text-align: center;
    line-height: 30px;
    width: 30px;
    height: 30px;
  }
}

#square {
  max-width: 650px;
  width: 650px;
  min-width: 650px;
  min-height: 300px;
  position: fixed;
  z-index: 999;
  top: 50%;
  left: 50%;
  margin-left: -275px;
  margin-top: -200px;
  box-shadow: 0 0 42px rgba(0, 0, 0, 0.7);
}

</style>
